import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'signal-icon',
  templateUrl: './signal-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SignalIconComponent {}
